export default __webpack_public_path__ + "static/media/footer_discord.3b532207.svg";